import {Component, ViewChild} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {SessionModel} from "../../orchestration/session.model";
import {PaymentModel} from "../../payment/payment.model";
import parsePhoneNumber, {PhoneNumber} from "libphonenumber-js";
import {Page} from "../../orchestration/page";
import {FormComponent} from "../../inputs/form/form.component";
import {MessageLevel} from "../../notification/message/message";
import {OrderingContextModel} from "../../ordering-context/ordering-context.model";
import {NavigationParams} from "../../orchestration/navigation-params";
import {WalletProvider} from "../../payment/payment";

@Component({
    selector: "woa-phone-edit-page",
    templateUrl: "./phone-edit-page.component.html",
    providers: [{provide: Page, useExisting: PhoneEditPageComponent}]
})
export class PhoneEditPageComponent extends Page {
    @ViewChild(FormComponent) public form: FormComponent;

    MessageLevel = MessageLevel;

    suppliedMobilePhone: string;
    confirmedMobilePhone: string;

    constructor(navigationParams: NavigationParams,
                private navigationService: NavigationService,
                private paymentModel: PaymentModel,
                public orderingContextModel: OrderingContextModel,
                public sessionModel: SessionModel) {
        super();
        this.suppliedMobilePhone = navigationParams.get("mobilePhone");
        if (this.suppliedMobilePhone && this.suppliedMobilePhone.startsWith("+")) {
            const phoneNumber: PhoneNumber = parsePhoneNumber(this.suppliedMobilePhone);
            const localPhoneNumber: string = "+" + this.sessionModel.currentApp.expectedCountryCode + <string>phoneNumber.nationalNumber;
            if (this.sessionModel.isValidMobileNumberForSms(localPhoneNumber)) {
                this.confirmedMobilePhone = localPhoneNumber;
            }
        } else if (this.sessionModel.isValidMobileNumberForSms(this.suppliedMobilePhone)) {
            this.confirmedMobilePhone = this.suppliedMobilePhone;
        }
    }

    get error(): string {
        const walletProvider: WalletProvider = this.paymentModel.walletPaymentProcessor ? this.paymentModel.walletPaymentProcessor.walletProvider : undefined;

        return !this.suppliedMobilePhone ? (walletProvider === WalletProvider.APPLE_PAY ? "woa.message.phone.missing.applyPay"
                : walletProvider === WalletProvider.GOOGLE_PAY ? "woa.message.phone.missing.googlePay"
                    : "woa.message.phone.missing.non-integrated")
            : this.sessionModel.isValidMobileNumberForSms(this.suppliedMobilePhone) ? (walletProvider === WalletProvider.APPLE_PAY ? "woa.message.phone.invalid.applyPay"
                    : walletProvider === WalletProvider.GOOGLE_PAY ? "woa.message.phone.invalid.googlePay"
                        : "woa.message.phone.invalid.non-integrated")
                : (walletProvider === WalletProvider.APPLE_PAY ? "woa.message.phone.non-mobile.applyPay"
                    : walletProvider === WalletProvider.GOOGLE_PAY ? "woa.message.phone.non-mobile.googlePay"
                        : "woa.message.phone.non-mobile.non-integrated");
    }

    get instructions(): string {
        return !this.suppliedMobilePhone ? "woa.message.phone.instructions.missing"
            : this.sessionModel.isValidMobileNumberForSms(this.suppliedMobilePhone) ? "woa.message.phone.instructions.invalid"
                : "woa.message.phone.instructions.non-mobile";
    }

    confirmPhone(): void {
        if (!this.form.valid) {
            return;
        }

        // noinspection JSIgnoredPromiseFromCall
        this.navigationService.dismissPage(this, {
            confirmed: true,
            mobilePhone: this.confirmedMobilePhone
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/customer-info/phone-edit-page/phone-edit-page.component.ts